import { Component, EventEmitter, input, Input, OnInit, Output } from '@angular/core';
import { LayerFilter, LayerFilterCategory } from 'projects/leaflet/src/public-api';
import { FilterDialogService } from 'projects/frontend/src/app/filters-dialog/filter-dialog.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Map } from 'projects/leaflet/src/lib/map';
import { DescDialogComponent } from '../desc-dialog/desc-dialog.component';
import { FilterService } from 'projects/frontend/src/app/services/filter.service';
import { OAuthService } from 'angular-oauth2-oidc';
const DEFAULT_FILTER_FUNCTION = (filters?: LayerFilter[]) => {
  const text = filters?.map(x => x.value)?.join(' OR ');
  return text ? `(${text})` : '';
}

@Component({
  selector: 'emodnet-menu-selector',
  templateUrl: './menu-selector.component.html',
  styleUrls: ['../menu/menu.component.scss'],
})
export class MenuSelectorComponent implements OnInit {

  @Output() filtersSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() parentCategory?: LayerFilterCategory;
  @Input() categories?: any[];
  @Input() map?: Map;
  @Output() activateTimeFilterRequest = new EventEmitter<any>();
  @Output() activateCustom = new EventEmitter<any>();

  constructor(
    private FilterDialogService: FilterDialogService,
    public dialog: MatDialog,
    private filterService: FilterService,
    private OAuth: OAuthService
  ) { }
  public search_data_network: string = '';
  public search_data_provider: string = '';
  public data_network_filtered: Array<any> = [];
  public data_provider_filtered: Array<any> = [];
  public theMap?: Map;

  ngOnInit(): void {
    this.theMap = this.map;
  }

  get token() {
    return this.OAuth.getAccessToken();
  }

  selectFilters(category: any, selected: boolean, parentCategory?: LayerFilterCategory) {
    if (parentCategory?.exclusive)
      parentCategory.categories?.forEach(x => {
        x.selected = !selected;
        x.filters?.forEach(f => f.selected = false);
      });

    category.selected = selected;
    category.filters?.forEach((f:any) => f.selected = selected);

    if (parentCategory?.id == 'times') {
      if (category.name == 'Custom') {
        category.selected = false;
        this.FilterDialogService.openDialog(this.map);
      }
    } else if (parentCategory?.id == 'customFilter') {
      this.activateTimeFilterRequest.emit(category.timeFilter);
      category.filters?.forEach((f:any) => {
        f.filter = f.value?.toString();
      });
    } else {
      category.filters?.forEach((f:any )=> {
        f.filter = f.value?.toString();
      });
      if (parentCategory?.name === 'research infrastructure' && category.name.toLowerCase().includes('sios')) {
        this.theMap?.setView([78.72, 19.51]);
        this.theMap?.zoomOut(1);
      } else if(parentCategory?.name === 'research infrastructure' && !category.name.toLowerCase().includes('sios')) {
        this.theMap?.setView([0,0]);
      }
    }

    this.filtersSelected.emit(selected);
  }

  performFilterSearch(event: any, item: any) {
    if (item.id === 'data_network') {
      let list = item.categories[0].categories;
      this.search_data_network = event;
      this.data_network_filtered = list.filter((item: any) => item.name.toLowerCase().includes(event.toLowerCase()));
    } else if (item.id === 'data_providers') {
      let list = item.categories.filter((item: any) => item.name.toLowerCase().includes(event.toLowerCase()));
      this.search_data_provider = event;
      this.data_provider_filtered = list.filter((item: any) => item.categories.filter((i: any) => i.name.toLowerCase().includes(event.toLowerCase())));
    }
  }

  public openDialog(e: any, description: string, title: string) {
    e.stopPropagation();
    e.preventDefault();
    this.dialog.open(DescDialogComponent, {
      data: {
        title: title,
        desc: description,
      }
    });

  }

  delete(name: any) {
    this.categories = this.categories?.filter((c)=> c.name !== name);
    this.parentCategory!.categories = this.categories;
    localStorage.setItem('custom-filter', JSON.stringify(this.parentCategory));
    this.filterService.sendFilter(this.categories);
    if (this.token) {
      const authid = this.OAuth.getIdentityClaims()['sub'];
      this.filterService.saveLoggedFilter(this.parentCategory as any, authid).subscribe(
        (res)=>{
          console.log('success update filter', res);
        },
        (error)=>{
          console.log('error on save filter in delete',error);
        }
      )
    }
  }


}
